import React, { } from 'react';

import { Stack } from '@mui/material';

import Button from '../../../../components/Button';
import ContentCard from '../../../../components/ContentCard';
import {
  useArchiveClassMutation,
  useGraduateClassMutation,
  useReviveClassMutation,
} from '../../../../services/classes';
import { Class } from '../../../../services/classes/types';
import useError from '../../../../utils/react/hooks/useError';
import useSuccess from '../../../../utils/react/hooks/useSuccess';

interface ClassSettingsCardProps {
  classObj: Class;
}

const ClassSettingsCard = ({ classObj }: ClassSettingsCardProps) => {
  const [archiveClass, { isLoading: isArchiving,
    isError: isArchiveClassError,
    error: archiveClassError,
    isSuccess: isArchivedClassSuccess }] = useArchiveClassMutation();

  const [reviveClass, { isLoading: isReviving,
    isError: isReviveClassError,
    error: reviveClassError,
    isSuccess: isReviveClassSuccess }] = useReviveClassMutation();

  const [graduateClass, { isLoading: isGraduating,
    isError: isGraduateClassError,
    error: graduateClassError,
    isSuccess: isGraduatedClassSuccess }] = useGraduateClassMutation();

  const handleClassState = () => {
    if (classObj.active) {
      archiveClass({
        subject: classObj.subject,
        classId: classObj.classId,
      });
    } else {
      reviveClass({
        subject: classObj.subject,
        classId: classObj.classId,
      });
    }
  };

  useError(isArchiveClassError, archiveClassError);
  useSuccess(isArchivedClassSuccess, 'Class archived successfully');

  useError(isReviveClassError, reviveClassError);
  useSuccess(isReviveClassSuccess, 'Class revived successfully');

  useError(isGraduateClassError, graduateClassError);
  useSuccess(isGraduatedClassSuccess, 'Class graduated successfully');

  return (
    <ContentCard title="Class Settings" variant="outlined">
      <Stack spacing={2} direction="row">
        <Button
          color={classObj.active ? 'error' : 'success'}
          onClick={handleClassState}
          loading={isArchiving || isReviving}
        >
          {classObj.active ? 'Archive Class' : 'Unarchive Class'}
        </Button>
        {classObj.active && (
          <Button
            color="warning"
            onClick={() => graduateClass({
              subject: classObj.subject,
              classId: classObj.classId,
            })}
            loading={isGraduating}
          >
            Graduate Class
          </Button>
        )}
      </Stack>
    </ContentCard>
  );
};
export default ClassSettingsCard;
